import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Row, Col, Input, Button } from 'antd';
import { isEmpty, isEqual } from 'lodash';

import './FMFormModal.css';

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const phoneRegex = /^\+?[0-9]{6,15}$/;

@inject('translationsStore')
@observer
export default class FMFormModal extends Component {
  constructor(props) {
    super(props);
    this.defaultValues = {
      name: '',
      surname: '',
      companyName: '',
      email: '',
      pec: '',
      mobile: '',
      phone: '',
      address: '',
      uin: ''
    };
    this.state = this.defaultValues;
  }

  componentDidMount() {
    if (!isEmpty(this.props.data)) {
      this.loadPropData(this.props.data);
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEmpty(this.props.data) && !isEqual(this.props.data, prevProps.data)) {
      this.loadPropData(this.props.data);
    }
  }

  loadPropData = () => {
    let data = this.props.data;
    data = { ...data, address: (data.address || {}).street || '' };
    this.setState(data);
  };

  validateAndSend = () => {
    let isValid = true;

    if(this.state.email && isValid) {
      isValid = isValid && !this.state.isEmailInvalid;
    }
    if(this.state.pec && isValid) {
      isValid = isValid && !this.state.isPecInvalid;
    }
    if(this.state.mobile && isValid) {
      isValid = isValid && !this.state.isMobileInvalid;
    }
    if(this.state.phone && isValid) {
      isValid = isValid && !this.state.isPhoneInvalid;
    }

    if(isValid){
      this.props.onSubmit(this.state);
    }
  };

  checkEmail = email => !!emailRegex.exec(email);

  checkPhone = phone => !!phoneRegex.exec(phone);

  onChangeChecked = fieldName => e =>{
    if(fieldName === 'email'){
      this.checkEmail(e.target.value)? this.setState({isEmailInvalid: false, email : e.target.value}) : this.setState({isEmailInvalid: true, email : e.target.value});
    }
    if(fieldName === 'pec'){
      this.checkEmail(e.target.value)? this.setState({isPecInvalid: false, pec : e.target.value}) : this.setState({isPecInvalid: true, pec : e.target.value});
    }
    if(fieldName === 'mobile'){
      this.checkPhone(e.target.value)? this.setState({isMobileInvalid: false, mobile : e.target.value}) : this.setState({isMobileInvalid: true, mobile : e.target.value});
    }
    if(fieldName === 'phone'){
      this.checkPhone(e.target.value)? this.setState({isPhoneInvalid: false, phone : e.target.value}) : this.setState({isPhoneInvalid: true, phone : e.target.value});
    }
  };

  render() {
    const { translationsStore, visible, loading, submitError, submitLabel } = this.props;

    const formPass = {
      name: this.state.name !== '' || this.state.companyName !== '',
      surname: this.state.surname !== '' || this.state.companyName !== '',
      companyName: this.state.name !== '' || this.state.surname !== '' || this.state.companyName !== '',
      email: this.state.email !== '',
      uin: this.state.uin.length === 11 || this.state.uin.length === 16
    };

    const canSubmit = Object.values(formPass).reduce((acc, pass) => (pass === false ? false : acc), true);

    return (
      <Fragment>
        {visible && (
          <Modal
            title={translationsStore.translate('fleetManagers.edit.modal.title')}
            visible={visible}
            footer={null}
            onOk={this.props.onOk}
            onCancel={this.props.onCancel}
            width={760}
            className={this.props.className}
          >
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.name')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.name ? 'fixme' : ''}
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderName')}
                  onChange={e => this.setState({ name: e.target.value })}
                  value={this.state.name}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.surname')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.name ? 'fixme' : ''}
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderSurname')}
                  onChange={e => this.setState({ surname: e.target.value })}
                  value={this.state.surname}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.companyName')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.companyName ? 'fixme' : ''}
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderCompanyName')}
                  onChange={e => this.setState({ companyName: e.target.value })}
                  value={this.state.companyName}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.email')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.email ? 'fixme' : ''}
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderEmail')}
                  onChange={this.onChangeChecked('email')}
                  value={this.state.email}
                />
                {this.state.email && this.state.isEmailInvalid && <p className={'ErrorMessage'}>{translationsStore.translate('fleetManagers.form.errorEmailInput')}</p>}
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.pec')}</Col>
              <Col span={18}>
                <Input
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderPec')}
                  onChange={this.onChangeChecked('pec')}
                  value={this.state.pec}
                />
                {this.state.pec && this.state.isPecInvalid && <p className={'ErrorMessage'}>{translationsStore.translate('fleetManagers.form.errorPecInput')}</p>}
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.mobile')}</Col>
              <Col span={18}>
                <Input
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderMobile')}
                  onChange={this.onChangeChecked('mobile')}
                  value={this.state.mobile}
                />
                {this.state.mobile && this.state.isMobileInvalid && <p className={'ErrorMessage'}>{translationsStore.translate('fleetManagers.form.errorMobileInput')}</p>}
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.phone')}</Col>
              <Col span={18}>
                <Input
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderPhone')}
                  onChange={this.onChangeChecked('phone')}
                  value={this.state.phone}
                />
                {this.state.phone && this.state.isPhoneInvalid && <p className={'ErrorMessage'}>{translationsStore.translate('fleetManagers.form.errorPhoneInput')}</p>}
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.address')}</Col>
              <Col span={18}>
                <Input.TextArea
                  rows={4}
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderAddress')}
                  onChange={e => this.setState({ address: e.target.value })}
                  value={this.state.address}
                />
              </Col>
            </Row>
            <Row>
              <Col span={6}>{translationsStore.translate('fleetManagers.form.uin')}</Col>
              <Col span={18}>
                <Input
                  className={!formPass.uin ? 'fixme' : ''}
                  placeholder={translationsStore.translate('fleetManagers.form.placeholderUin')}
                  onChange={e => this.setState({ uin: e.target.value })}
                  value={this.state.uin}
                />
              </Col>
            </Row>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              {submitError && <div style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>{submitError}</div>}
              <Button type="primary" onClick={this.validateAndSend} disabled={!canSubmit || loading}>
                {submitLabel}
              </Button>
            </div>
          </Modal>
        )}
      </Fragment>
    );
  }
}
